export default __webpack_public_path__ + "static/media/ufc_shop_logo.ad363c4e.jpg";